import { Separator } from "@/components/ui/separator";
import type { VouchFeedbackProps } from "@/lib/types";
import { HeartHandshake, Lock } from "lucide-react";

const NegativeVouchFeedback = ({ vouchee }: VouchFeedbackProps) => {
  return (
    <div className="mx-auto flex w-full max-w-sm flex-col items-center gap-8 text-center">
      <div className="animate-support flex size-16 shrink-0 items-center justify-center rounded-full bg-muted">
        <HeartHandshake
          className="size-7 text-muted-foreground"
          aria-hidden="true"
        />
      </div>
      <div className="flex flex-col gap-3">
        <h2 className="text-4xl text-foreground">Thank you for your honesty</h2>
        <p className="leading-relaxed text-accent-foreground">
          Your response has been recorded privately. Honesty like this keeps
          this community trustworthy and safe.
        </p>
      </div>
      <Separator />
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Lock className="size-3.5 shrink-0" aria-hidden="true" />
        <span>
          Never shared{vouchee?.firstName ? ` with ${vouchee.firstName}` : ""}
        </span>
      </div>
    </div>
  );
};

export default NegativeVouchFeedback;
